export function customQuantity() {
    $('form').on('click', '.plus, .minus', function () {

        // Get current quantity values
        let qty = $(this).closest('.tribe-tickets-form-row, .cart_item, .holder-quantity').find('.qty');
        let val = parseFloat(qty.val());
        let max = parseFloat(qty.attr('max'));
        let min = parseFloat(qty.attr('min'));
        let step = parseFloat(qty.attr('step'));

        // Change the value if plus or minus
        if ($(this).is('.plus')) {
            if (max && (max <= val)) {
                qty.val(max).change();
            } else {
                qty.val(val + step).change();
            }
        } else {
            if (min && (min >= val)) {
                qty.val(min).change();
            } else if (val >= 1) {
                qty.val(val - step).change();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/woo-quantity.js